const GlobalMsgCons: { [key: string]: string } = {
  success: "success",
  invalidRequest: "Invalid Request",
  alreadyExist: "alreadyExist",
  passwordMismatch: "passwordMismatch",
  notExist: "notExist",
  inActiveAccount: "inActiveAccount",
};

export default GlobalMsgCons;
